import vuwer from "@pressmedia/vuwer";
import "./assets/klass/VuwFuncBlock";
import "./assets/klass/VuwSearchForm";

// components
import "./components/appNav";
import "./components/homeSection";
import "./components/listSection";
import "./components/editSection";
import "./components/previewSection";

const { app, Klass } = window;
if( !Klass || !(app instanceof Klass("WebAppBase") ) ) {
	throw new TypeError("The 'app' is not defined.");
}


async function getReady() {
	const res = await Promise.all([
		vuwer.get("appNav").getReady(),
		vuwer.get("homeSection").getReady(),
		vuwer.get("listSection").getReady(),
		vuwer.get("editSection").getReady(),
		vuwer.get("previewSection").getReady()
	]);
	
	// seach and set childSections
	vuwer.readChildSections();
	
	// メニュー項目をセット
	const menu = {
		home: app.ttls.subttls.home,
		...app.config.menu
	};
	
	await Promise.all([
		app.nav.get("menu").setState("items", menu || {}),
		vuwer.get("homeSection").setState("menu", menu || {})
	]);
	
	app.config.menu = menu;
	
	return res;
}

export default getReady;
